import styled from 'styled-components';
import { colors } from 'app/shared/styles/_colors';
import ListingWrapperBase from 'app/shared/modules/listing-cards/ListingWrapper';
import { font } from 'app/shared/styles/_fontsize';
import { inline, inset, stacked } from 'app/shared/styles/_spacing';
import type { ComponentType } from 'react';

// Components
import ListingCardsSmallBase from 'app/shared/modules/listing-cards/ListingCard';

export const RecommendedText = styled.p`
  ${font.md};
  ${inset._1x};
`;

export const ContactCtaArticle = styled.article`
  ${inset._2x};
  padding-bottom: 0px;
  text-align: left;
`;

export const ContactTextHeading = styled.h2`
  ${font.lg};
  ${stacked._2x};
  font-weight: bold;
`;

export const ContactTextBody = styled.p`
  ${font.md};
  ${stacked._2x};
`;

export const ListingWrapper: ComponentType<React.ComponentProps<typeof ListingWrapperBase>> = styled(
  ListingWrapperBase,
)`
  width: 100%;
`;

export const ListingCardsSmall = styled(ListingCardsSmallBase)`
  ${inline._2x};
`;

export const OuterScrollContainer = styled.article`
  ${inset._2x};
`;

export const ListContainer = styled.ul`
  /* padding: 24px 16px 0 16px; */
  padding-top: 16px;
  padding-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  overflow-x: auto;
  overflow-y: hidden;
  row-gap: 28px;
`;

export const ListItem = styled.li`
  ${inline._1x};
  flex-shrink: 0;
`;

export const SelectAllContainer = styled.div`
  ${inset._2x};
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Checkbox = styled.input`
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
  border: 2px solid ${colors['$hpx-grey-400']};
  border-radius: 4px;
  background-color: ${colors['$hpx-white']};
  position: relative;
  transition: all 0.2s ease;

  &:hover:not(:disabled) {
    border-color: ${colors['$hpx-teal-500']};
  }

  &:checked {
    background-color: ${colors['$hpx-teal-500']};
    border-color: ${colors['$hpx-teal-500']};
  }

  &:checked::after {
    content: '';
    position: absolute;
    left: 6px;
    width: 5px;
    height: 14px;
    border: solid ${colors['$hpx-white']};
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const Label = styled.label`
  ${font.md};
  cursor: pointer;
  user-select: none;
  color: ${colors['$hpx-blue-600']};
`;

export const Footer = styled.div`
  position: sticky;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 16px;
  border-top: 1px solid ${colors['$hpx-grey-400']};
  background-color: ${colors['$hpx-white']};
  margin-top: auto;
`;

export const Container = styled.article`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  height: 100%;
`;

export const ScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
`;
